module.exports = __webpack_public_path__ + "static/media/icon_arrow_circle_right.8ce1709f.svg";